export default "__VITE_ASSET__BZlUf7xf__"